"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TooltipIcon_1 = require("../components/TooltipIcon");
var UnmanagedTooltipIcon_1 = require("../components/UnmanagedTooltipIcon");
var React = require("react");
var classNames = require("classnames");
/**
 * Returns the tooltip extended by the provided class or wraps the content
 * within a TooltipIcon if tooltip itself is not a TooltipIcon.
 *
 * @param tooltipClassName the provided class name will be set on the TooltipIcon
 * @param tooltip the tooltip content or element
 */
exports.ensureTooltipIcon = function (tooltipClassName, tooltip) {
    var tooltipElement = null;
    if (tooltip) {
        if (typeof tooltip !== 'string' &&
            ((JSON.stringify(tooltip.type) === JSON.stringify(TooltipIcon_1.TooltipIcon))
                || (JSON.stringify(tooltip.type) === JSON.stringify(UnmanagedTooltipIcon_1.UnmanagedTooltipIcon)))) {
            tooltipElement = React.cloneElement(tooltip, {
                className: classNames(tooltip.props.className, tooltipClassName)
            });
        }
        else {
            tooltipElement = React.createElement(TooltipIcon_1.TooltipIcon, { className: tooltipClassName }, tooltip);
        }
    }
    return tooltipElement;
};
exports.default = exports.ensureTooltipIcon;
//# sourceMappingURL=tooltip.js.map